import { useInkind } from '@gik/api/inkinds/inkind';
import withSuspense from '@gik/core/components/suspended/withSuspense';
import H1Bone from '@gik/ui/SkeletonLoader/Bones/H1Bone';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { translationKeys } from './i18n/en';

interface IWishlistPageHeaderProps {
  inkindRouteId: string;
}

const Skeleton = () => <H1Bone />;

function WishlistPageHeader({ inkindRouteId }: IWishlistPageHeaderProps) {
  const { t } = useTranslation();
  const { data: inkindPage, error: inkindPageError } = useInkind(inkindRouteId);

  const isLoading = !inkindPage;
  const isError = isLoading && inkindPageError;

  if (isLoading) return <Skeleton />;
  if (isError) return <Skeleton />;

  return (
    <h1>
      {t(translationKeys.title, {
        inkindPageTitle: inkindPage?.title,
      })}
    </h1>
  );
}

export default withSuspense(WishlistPageHeader, Skeleton);
